export enum SelectionBehavior {
    PROPAGATE_TO_PARENT = "PROPAGATE_TO_PARENT",
    PROPAGATE_TO_CHILDREN = "PROPAGATE_TO_CHILDREN",
    SELF_ONLY = "SELF_ONLY",
    DISABLED = "DISABLED"
}
